export default __webpack_public_path__ + "static/media/onboarding-logo.4183447c.png";